import QueryHookFactory from "utilities/hooks/queries/query-hook-factory";
import HubspotFormRecord from "models/view-models/hubspot-form-record";
import ServiceHookFactory from "utilities/services/service-hook-factory";
import HubspotFormSubmissionRecord from "models/view-models/hubspot-form-submission-record";

// -------------------------------------------------------------------------------------------------
// #region Interfaces
// -------------------------------------------------------------------------------------------------

export interface HubspotFormPathParams {
    formId: string;
}
export interface HubspotFormSubmitPathParams extends HubspotFormPathParams {
    portalId: number;
}

// #endregion Interfaces

// -------------------------------------------------------------------------------------------------
// #region Constants
// -------------------------------------------------------------------------------------------------

const baseEndpoint = "external/hubspot/form";
const resourceEndpoint = `${baseEndpoint}/:formId`;
const submitEndpoint = `${baseEndpoint}/:portalId/:formId`;
const key = "hubspot-form";
const resourceType = HubspotFormRecord;

// #endregion Constants

// -------------------------------------------------------------------------------------------------
// #region Service
// -------------------------------------------------------------------------------------------------

const HubspotFormService = {
    key,
    useGetQuery: QueryHookFactory.useGetQuery<
        HubspotFormRecord,
        HubspotFormPathParams
    >(key, resourceType, resourceEndpoint),
    useCreate: ServiceHookFactory.useNestedCreate<
        HubspotFormSubmissionRecord,
        HubspotFormSubmitPathParams
    >(HubspotFormSubmissionRecord, submitEndpoint),
};

// #endregion Service

// -------------------------------------------------------------------------------------------------
// #region Exports
// -------------------------------------------------------------------------------------------------

export default HubspotFormService;

// #endregion Exports
